import React from 'react';

import { PasswordProtection } from '@components/password-protection';
import { ThemeProvider } from '@contexts/theme-context';
import { LanguageProvider } from '@contexts/language-context';

interface DiagnosticLayoutProps {
  children: React.ReactNode;
}

export const DiagnosticLayout: React.FC<DiagnosticLayoutProps> = ({ children }) => {
  return (
    <PasswordProtection>
      <ThemeProvider>
        <LanguageProvider>{children}</LanguageProvider>
      </ThemeProvider>
    </PasswordProtection>
  );
};
